import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { ErrorMessageInterceptor } from '@capturum/complete';
import { GUEST_DOWNLOAD_URL_FRAGMENT } from '@features/guest/models/transition-document-download.model';

@Injectable({ providedIn: 'root' })
export class CustomErrorMessageInterceptor extends ErrorMessageInterceptor {
    public catchErrorLogic(err: HttpErrorResponse, request?: HttpRequest<any>): void {
        if (err.url?.includes(GUEST_DOWNLOAD_URL_FRAGMENT)) {
            return;
        }

        super.catchErrorLogic(err, request);
    }

    public exceptionUrls(err: HttpErrorResponse): boolean {
        if (err.status === HttpStatusCode.UnprocessableEntity && err.url?.includes('/transition-document/') && err.url?.endsWith('/answers')) {
            return false;
        }

        if (err.status === HttpStatusCode.Conflict && err.url?.includes('/transition-document/') && err.url?.endsWith('/reopen')) {
            return false;
        }

        return super.exceptionUrls(err);
    }
}
